import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {VmiArticulosService} from '../../../services/administracion/vmi-articulos.service';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';

@Component({
  selector: 'app-vmi-frm-mantenedor-reporte-diario',
  templateUrl: './vmi-frm-mantenedor-reporte-diario.component.html',
  styleUrls: ['./vmi-frm-mantenedor-reporte-diario.component.css']
})
export class VmiFrmMantenedorReporteDiarioComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _articulos: VmiArticulosService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.reporteDiario;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      codGerencia: [{
        value: '',
        disabled: false
      }, [Validators.required, Validators.minLength(1), Validators.maxLength(6)]],
      nivel: [{value: '', disabled: false}, [Validators.required, Validators.min(1), Validators.max(6)]],
      precMin: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(15)]],
      precMax: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(15)]]
    });

    this.gridComponent();
    this.getAll();
  }

  //*SERVICIOS
  getAll() {
    this._articulos.getAll().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'CODIGO',
        field: 'codGerencia',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'NIVEL',
        field: 'nivel',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'PRECIO MIN',
        field: 'precMin',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'PRECIO MAX',
        field: 'precMax',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editar({rowData}) {
    const obj = {
      codGerencia: rowData.codGerencia,
      nivel: rowData.nivel,
      precMin: rowData.precMin,
      precMax: rowData.precMax,
    };
    this.formulario.get('codGerencia').disable();
    this.formulario.get('nivel').disable();
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._articulos.delete(rowData.codGerencia),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.regresar();
    }
  }

  guardar() {
    const obj: any = this.formulario.value;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._articulos.create(obj),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    let obj: any = this.formulario.value;
    obj.codGerencia = this.formulario.get('codGerencia').value;
    obj.nivel = this.formulario.get('nivel').value;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._articulos.edit(obj),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

}
